module.exports = __webpack_public_path__ + "media/images/logos/logo-us-cd96d26fc7faa971b18f5b1bebc019c7.svg";